import { envConfig } from '../env';

export const FAVICON_LOGO_PATH = '/favicon/logo.svg';
export const TERMS_URL =
  `${envConfig.VITE_LANDING_URL}/assets/FCB_NA_LTD_Terms_of_Service.pdf`;
export const PRIVACY_POLICY_URL =
  `${envConfig.VITE_LANDING_URL}/assets/FCB_NA_LTD_Privacy_Policy.pdf`;
